import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'semantic-ui-react';

import * as userLib from 'libs/userLib';
import * as targetActions from 'modules/target';

import { AdminTargetEditModal } from 'components';

class CtAdminTargetAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      editModal: false
    };
  }

  mountEditModal = () => {
    const { editModal } = this.state;

    if (editModal) {
      // 열려진 경우로 닫는다.
      this.setState({ editModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ editModal: true });
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, editModal } = this.state;
    const { isAuth } = this.props;
    const { mountEditModal } = this;

    return (
      <div>
        <Button
          className="bt-style-gleam common-button-brand"
          size="small"
          content={defineMessages(formatMessage({ id: 'CtAdminUserAdd_1', defaultMessage: '등 록' }))}
          onClick={mountEditModal}
          // color="blue"
        />
        {editModal && <AdminTargetEditModal addMode isAuth={isAuth} mountEditModal={mountEditModal} />}
      </div>
    );
  }
}

CtAdminTargetAdd.propTypes = {};
CtAdminTargetAdd.defaultProps = {};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  TargetActions: bindActionCreators(targetActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminTargetAdd));



// WEBPACK FOOTER //
// ./src/script/containers/admin/target/CtAdminTargetAdd.js